let baseURL = ''
const url = location.href;
if (url.indexOf('http://localhost') != -1) { // 本地环境
    baseURL = 'https://cloud-pc-api-yc.gymooit.cn'
} else if (url.indexOf('zy-admin.gymooit') != -1) { // 测试环境
    baseURL = 'https://cloud-pc-api-yc.gymooit.cn'
} else { // 正式环境
    baseURL = 'https://cloud-pc-api-yc.gymooit.cn'
}
export default baseURL;
